import React from 'react';
import { TextField } from '@mui/material';

interface CallNotesFieldProps {
  value: string;
  error: string;
  onChange: (value: string) => void;
}

export const CallNotesField: React.FC<CallNotesFieldProps> = ({
  value,
  error,
  onChange
}) => {
  return (
    <TextField
      label="Call Notes"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      error={!!error}
      helperText={error || 'Record what was discussed, outcomes, follow-up needed, etc.'}
      multiline
      rows={4}
      size="small"
      required
      fullWidth
      InputProps={{
        sx: {
          '& .MuiInputBase-inputMultiline': {
            whiteSpace: 'pre-wrap'
          }
        }
      }}
    />
  );
};
